export default __webpack_public_path__ + "static/media/1.1a75702a.png";